<div class="sticky-bar">
  <div class="w3-container w3-padding-12" style="background:white;">
    <div class="row">
      <div class="w3-col m1 w3-hide-small">
        <img src="../../../assets/activitiesImages/logo_gov.png">
      </div>
      <div class="w3-left w3-margin-top w3-padding-12" style="width: 150px;">
        <img src="../../../assets/activitiesImages/cada_logo.png">
      </div>
      <div class="w3-col m5">
        <!-- <h3 style="font-weight:bold; margin-bottom:0px; margin-top:30px; color: #a91e22; font-size: 1.4rem;">
          Micro
          Irrigation &amp;
          Command Area
          Development Authority, Haryana</h3> -->
          <h3 style="font-weight:bold; margin-bottom:0px; margin-top:30px; color: #a91e22; font-size: 1.4rem;">
            {{'MICADA_HEADING'| translate}}</h3>
        <!-- <span style="color: #a91e22"><b> (Formerly CADA) </b></span> -->
      </div>
    </div>

    <div class="w6-col m3 w3-right button-div d-flex" style="text-align: right;">
      <!-- <div class="field-checkbox justify-content-center" style="margin-right:3px;"> 
      
   </div>  -->
   <label><b>{{'LANGUAGE' | translate}} :</b></label>
   <p-dropdown [(ngModel)]="selectedLang"[options]='[{name: "English", code:"en"}, {name: "Hindi",code:"hd"}]' optionLabel="name"
   (onChange)="languageChange($event)" style="margin-left: 2px">
</p-dropdown>
      <button type="button" class="button-33 mx-3"><a [routerLink]="['/login']"><b>{{'LOGIN'| translate}}</b></a></button>
      <button pButton class="button-33 mx-3" type="button"><a [routerLink]="['/phone-login']"><b>{{'FARMER_LOGIN'| translate}}</b></a></button>
    </div>
  </div>

  <section class="top-nav">
    <input id="menu-toggle" type="checkbox" />
    <label class='menu-button-container' for="menu-toggle">
      <div class='menu-button'></div>
    </label>
    <ul class="menu" style="display: flex; justify-content: center;">
      <li><a [routerLink]="['/home']">{{'HOME'| translate}}</a></li>
      <li><a href="https://etenders.hry.nic.in/nicgep/app" target="_blank">{{'TENDER/EOI'| translate}}</a></li>
      <li><a [routerLink]="['/activities']">{{'ACTIVITIES'| translate}}</a></li>
      <li><a [routerLink]="['/officeOrders']">{{'OFFICE_ORDERS'| translate}}</a></li>
      <li><a [routerLink]="['/statistics']">{{'STATISTICS'| translate}}</a></li>
      <li><a href="https://micada.haryana.gov.in:7002/" target="_blank">{{'CADMIS'| translate}}</a></li>
      <li><a [routerLink]="['/rti']">{{'RTI'| translate}}</a></li>
      <li><a [routerLink]="['/new-initiatives']">{{'NEW_INTIATIVES'| translate}}</a></li>
      <li><a [routerLink]="['/org-setup']">{{'ORGANIZATIONAL_SETUP'| translate}}</a></li>
    </ul>
  </section>
</div>


<div class="w3-col m10 w3-margin-top top-container1" style="width: 100%; height: 100%; display: block;">
  <div class="w3-container">
    <p-galleria [value]="images" [responsiveOptions]="responsiveOptions"
      [containerStyle]="{'max-width': '100%', 'height': '100%'}" [numVisible]="5" [showThumbnails]="false"
      [showIndicators]="true" [changeItemOnIndicatorHover]="true" [autoPlay]="true" [transitionInterval]="3000"
      [circular]="true">
      <ng-template pTemplate="item" let-item>
        <img [src]="item.previewImageSrc" style="width: 100%; height: 350px; display: block;" />
      </ng-template>
      <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
          <img [src]="item.thumbnailImageSrc" style="display: block;" />
        </div>
      </ng-template>
    </p-galleria>
  </div>
</div>


<div class="row p-0 mt-4 lg:mt-0 pl-5 grid" style="width:100%;">
  <div class="col-12 md:col-4 lg:col-4" style="text-align: center;">
    <img src="../../../assets/activitiesImages/manhorlal.jpg" style="width:150px;height:130px; border-radius: 50%;">
    <p style="font-size:16px; color:rgb(168, 15, 15);"><b>{{'SH_MANOHAR_LAL'| translate}}<p
          style="font-size:12px; color:black; font-weight:bold">{{'CHIEF_MINISTER'| translate}}<br>
          {{'HARYANA'| translate}}</p></b></p>
  </div>
  <div class="col-12 md:col-4 lg:col-4" style="text-align: center;">
    <img src="../../../assets/activitiesImages/ACS.jpg" style="width:150px;height:130px; border-radius: 50%;">
    <p style="font-size:16px; color:rgb(168, 15, 15)"><b>{{'SH_PANKAJ_AGARWAL'| translate}}<p
          style="font-size:12px; color:black; font-weight:bold">{{'COMMMISSIONER_AND_SECRETARY'| translate}},<br>{{'IRRIGATION_AND_WATER_DEPT'| translate}} <br/>{{'HARYANA'| translate}}</p></b></p>
  </div>
  <div class="col-12 md:col-4 lg:col-4" style="text-align: center;">
    <img src="../../../assets/activitiesImages/admin.jpg" style="width:150px;height:130px; border-radius: 50%;">
    <p style="font-size:16px; color:rgb(168, 15, 15)"><b>{{'DR_SATBIR_SINGH'| translate}}<p
          style="font-size:12px; color:black; font-weight:bold">{{'ENGINNER_IN_CHIEF'| translate}}<br>
          {{'ADMINISTRATOR'| translate}}<br>
          {{'CADA_HARYANA'| translate}}</p></b></p><br>
  </div>
</div>

<div class="px-3">
  <div class="w3-col m2 w3-container w3-margin-bottom info-container1 w3-center w3-hover-shadow w3-border">
    <ul class="w3-ul w3-margin-top" style="font-size:12px;">

      <li class="w3-large w3-padding-16" style="background:darkseagreen; color:black"><b>{{'QUICK_LINKS'| translate}}</b></li>
      <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" style="max-height: 430px;">
        <li class="w3-padding-8 w3-left-align">{{'ADVERTISEMENT_DATE'| translate}}
          <a href="http://cada.hartron.io/assets/home/Appointment%20Regarding%20Document.pdf" target="_blank"><img
              src="../../../assets/activitiesImages/newitem.gif"></a>
        </li>
        <li class="w3-padding-8  w3-left-align">{{'WATER_POLICY'| translate}}<a
            href="http://cada.hartron.io/assets/home/waterpolicy2122.pdf" target="_blank"><img
              src="../../../assets/activitiesImages/newitem.gif"></a></li>

        <li class="w3-padding-8  w3-left-align">{{'FARMER_ONLINE_APP_WEB_PORTAL_FOR_MI'| translate}}<a
            href="http://cada.hartron.io/phone-login" target="_blank">
            <img src="../../../assets/activitiesImages/newitem.gif">
          </a></li>
        <li class="w3-padding-8  w3-left-align">MICADA PORTAL से सम्बंधित योजनाओ की जानकारी हेतु आप हेल्पलाइन संख्या
          0172 - 2800610 पर 9.00 AM to 5.00 PM संपर्क कर सकते है</li>
        <li class="w3-padding-8  w3-left-align">{{'ON_FARM_WATER_TANK_POLICY'| translate}}
          <a href="http://cada.hartron.io/assets/home/On%20Farm%20Water%20Tank%20Policy%20Final-%202020-21.pdf"
            target="_blank">
            <img src="../../../assets/activitiesImages/newitem.gif"></a>
        </li>

        <li class="w3-padding-8  w3-left-align">{{'IMPLEMENTATION_GUIDELINES'| translate}}
          <a href="http://cada.hartron.io/assets/home/Guidelines%20MI.pdf" target="_blank"><img
              src="../../../assets/activitiesImages/newitem.gif"></a>
        </li>

        <li class="w3-padding-8  w3-left-align">{{'MI_CIRCULAR'| translate}}<a href="http://cada.hartron.io/home"
            target="_blank"><img src="../../../assets/activitiesImages/newitem.gif"></a></li>

        <li class="w3-padding-8  w3-left-align">{{'AAROGYA_SETU_IVRS'| translate}}<a
            href="http://cada.hartron.io/assets/home/AarogyaSetuIVRS.pdf" target="_blank"><img
              src="../../../assets/activitiesImages/newitem.gif"></a></li>
      </marquee>
    </ul>
  </div>


  <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB">
    <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3"><b>Projects Under
        Pipeline</b></h5>
    <p style="font-size:14px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>
        a) Projects submitted by CADA to
        Government of India, Ministry of Water Resources, RD&amp;GR, New Delhi for inclusion under the
        umbrella
        scheme of PMKSY - HKKP - ISBIG.</b></p>
    <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
      <b><strong>Pradhan Mantri
          Krishi Sinchayee Yojana (PMKSY)</strong> scheme is a Centrally Sponsored flagship scheme of
        Government of
        India. The GoI decided in December, 2016 to take up Command Area Development and Water Management
        (CADWM) works under the newly introduced scheme namely
        ‘Incentivization Scheme for Bridging the Irrigation Gap (ISBIG) under the umbrella scheme of
        PMKSY-HKKP.
        Haryana state has prepared and submitted 6 projects
        pertaining to CADWM Works to the concerned Ministry in GOI i.e. MOWR, RD&GR. The projects are under
        active consideration with GOI. As soon as approval is
        received from the GOI the same shall be implemented in Haryana State. The main objectives of the
        scheme
        are as under:-<br>
        (a) Completion of CADWM works along with correction of system deficiencies in canal network for
        bridging
        the gap between Irrigation Potential Created (IPC)<br>
        and Irrigation Potential Utilized (IPU).<br>
        (b) Improving the water use efficiency in irrigation and providing assured supply of water to every
        farm
        field; and<br>
        (c) Transfer of control and management of irrigation system to the Water Users’ Associations
        (WUAs).</b><br><br>

      <strong>The details of the projects submitted to GoI, MoWR for approval and inclusion under ISBIG are as
        under:-</strong><br>
    </p>

    <table class="w3-border" style="border-collapse:separate; margin-left:40px; width:90%;">
      <tr>
        <th>Sr.No.</th>
        <th>Name of Projects</th>
        <th>Physical Target(CCA in Ha.)</th>
        <th>
          Estimated cost of the Project(Rs. in lakh)</th>
        <th>Districts to be covered</th>
      </tr>
      <tr>
        <th colspan=5>A On-going Projects</th>
      </tr>
      <tr>
        <td>1</td>
        <td>BCC-II </td>
        <td>1,07,675 </td>
        <td>72984.18 </td>
        <td>Hisar, Sirsa,
          Fatebahad, Ambala, Kaithal, Kanal, Kurukshetra &amp; Jind</td>
      </tr>
      <tr>
        <td>2</td>
        <td>WJC-VI</td>
        <td>73,144</td>
        <td>49238.55</td>
        <td>
          Hisar, Rohtak, Jhajjar, Sonepat, Jind, Bhiwani &amp; Panipat</td>
      </tr>
      <tr>
        <td>3</td>
        <td>JLN-II</td>
        <td>88,704</td>
        <td>59495.00</td>
        <td>Jhajjar,
          Rewari, Mehandergarh, Bhiwani &amp; Gurgaon</td>
      </tr>
      <tr>
        <th colspan=5>B New Projects</th>
      </tr>
      <tr>
        <td>4</td>
        <td>BCC-III</td>
        <td>1,71,852</td>
        <td>111141.06</td>
        <td>Hisar,
          Sirsa, Fatebahad, Ambala, Kaithal, Kanal, Kurukshetra &amp; Jind</td>
      </tr>
      <tr>
        <td>
          5</td>
        <td>WJC-VII</td>
        <td>75,341</td>
        <td>49567.71</td>
        <td>Hisar, Rohtak,
          Jhajjar, Sonepat, Jind, Bhiwani &amp; Panipat</td>
      </tr>
      <tr>
        <td>6</td>
        <td>Siwani Project </td>
        <td>49,899</td>
        <td>31834.95</td>
        <td>
          Bhiwani</td>
      </tr>
      <tr>
        <td colspan=2>Total</td>
        <td>5,66,615</td>
        <td>374261.45</td>
        <td>NA</td>
      </tr>
    </table><br>


    <p style="font-size:14px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
      <b><strong>b)
          Micro Irrigation Projects under Micro Irrigation Fund - NABARD</strong><br></b>
    </p>
    <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
      <b>i) Project for Installation of Community Based Solar/Grid Powered Integrated Micro Irrigation
        Infrastructure with On-Farm Micro Irrigation in
        existing canal commands in various districts of Haryana under NABARD<br>
        To promote micro irrigation system in the fields of farmers, CADA has prepared a micro irrigation
        project with an estimated cost of Rs 189.46 crore for
        bringing 9022 hectares CCA of 13 districts namely Hisar, Fatehabad, Sirsa, Bhiwani, Kaithal, Karnal,
        Kurukshetra, Sonipat, Rohtak, Jhajjar, Jind, Rewari
        and Mahendragarh under Micro Irrigation Fund - NABARD. This project has already been approved by the
        State Government and NABARD. Work on this project will
        be started shortly.</b>
    </p>
    <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>
        ii) Project for installation of Community Based Solar/ Grid
        Powered Micro-Irrigation Infrastructure in Kheri Distributory of Fatehabad, Hisar &amp;
        Sirsa districts of Haryana under PPP Mode.<br>
        CADA has also prepared another micro irrigation project under PPP Mode with an estimated cost of Rs
        399.97 crore. Under this project, 22941 hectares CCA
        of Hisar, Fatehabad and Sirsa districts will be brought under micro irrigation. This project has
        already
        been approved by the State Government and NABARD.
        Work on this project will be started shortly.</b></p><br>

  </div>

  <div class="w3-col m2 w3-container w3-margin-bottom info-container3 w3-center w3-hover-shadow w3-border">
    <ul class="w3-ul w3-margin-top" style="font-size:12px;">

      <li class="w3-large w3-padding-16" style="background:darkseagreen; color:black"><b>{{'NEWS_AND_EVENTS'| translate}}</b></li>
      <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" style="max-height: 430px;">
        <li class="w3-padding-16 w3-left-align"><b>{{'FARMER_ONLINE_APPLICATION_FOR_MI'| translate}}</b><br>
          <p>{{'FARMER_ONLINE_APPLICATION_HAS_BEEN_INAUGURATED'| translate}}</p>
        </li>
        <li class="w3-padding-16  w3-left-align"><b>{{'CADA_ADMINISTRATOR'| translate}}</b><br>
          <p>{{'DR_SATBIR_SINGH_KADIAN_EIC'| translate}}</p>
        </li>

        <li class="w3-padding-16  w3-left-align"><b>{{'CADA_CHIEF_ENGINEER'| translate}}</b><br>
          {{'SH_SURESH_YADAV'| translate}}</li>

        <li class="w3-padding-24 w3-left-align"></li>
        <li class="w3-padding-16 w3-left-align"></li>
      </marquee>
    </ul>
  </div>
</div>


<div class="grid col-12 md:col-12 lg:col-12 p-0 mt-4 lg:mt-0 pl-5" style="width:100%;">
  <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2 dropdown">
      <div class="px-3" style="
          height: 160px;
          padding: 2px;
          border-radius: 10px;
          background: linear-gradient(
              90deg,
              rgba(253, 228, 165, 0.2),
              rgba(187, 199, 205, 0.2)
            ),
            linear-gradient(
              180deg,
              rgba(253, 228, 165, 0.2),
              rgba(187, 199, 205, 0.2)
            );
        ">
          <a class="p-3 h-full" style="border-radius: 8px">
              <div class="flex align-items-center justify-content-center bg-yellow-200 mb-3"
                  style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                  <i class="pi pi-fw pi-money-bill text-2xl text-yellow-700"></i>
              </div>
              <h5 class="mb-2 text-900">{{'FARMER_SHARE_PAYMENT'| translate}}</h5>
              <div class="dropdown-content">
                  <a href="assets/home/farmer_share_payment_s1.pdf" target="_blank">{{'FARMER_SHARE_LOT_1'| translate}}</a>
                  <a href="assets/home/farmer_share_payment_s2.pdf" target="_blank">{{'FARMER_SHARE_LOT_2'| translate}}</a>
                  <a href="assets/home/farmer_share_payment_s3.pdf" target="_blank">{{'FARMER_SHARE_LOT_3'| translate}}</a>
                  <a href="assets/home/farmer_share_payment_s4.pdf" target="_blank">{{'FARMER_SHARE_LOT_4'| translate}}</a>
                  <a href="assets/home/farmer_share_payment_s5.pdf" target="_blank">{{'FARMER_SHARE_LOT_5'| translate}}</a>
              </div>
          </a>
      </div>
  </div>

  <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2">
      <div class="px-3" style="
          height: 160px;
          padding: 2px;
          border-radius: 10px;
          background: linear-gradient(
              90deg,
              rgba(145, 226, 237, 0.2),
              rgba(251, 199, 145, 0.2)
            ),
            linear-gradient(
              180deg,
              rgba(253, 228, 165, 0.2),
              rgba(172, 180, 223, 0.2)
            );
        ">
          <a [routerLink]="['/evaluation-study']" class="p-3  h-full" style="border-radius: 8px">
              <div class="flex align-items-center justify-content-center bg-cyan-200 mb-3"
                  style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                  <i class="pi pi-fw pi-palette text-2xl text-cyan-700"></i>
              </div>
              <h5 class="mb-2 text-900">{{'EVALUATION_STUDY'| translate}}</h5>
          </a>
      </div>
  </div>

  <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5 mt-4 lg:mt-0">
      <div class="px-3" style="
          height: 160px;
          padding: 2px;
          border-radius: 10px;
          background: linear-gradient(
              90deg,
              rgba(145, 226, 237, 0.2),
              rgba(172, 180, 223, 0.2)
            ),
            linear-gradient(
              180deg,
              rgba(172, 180, 223, 0.2),
              rgba(246, 158, 188, 0.2)
            );
        ">
          <a [routerLink]="['/micro-irrigation']" class="p-3 h-full" style="border-radius: 8px">
              <div class="flex align-items-center justify-content-center bg-indigo-200"
                  style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                  <i class="pi pi-fw pi-map text-2xl text-indigo-700"></i>
              </div>
              <h5 class="mb-2 text-900">{{'MICRO_IRRIGATION'| translate}}</h5>
          </a>
      </div>
  </div>

  <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2">
      <div class="px-3" style="
          height: 160px;
          padding: 2px;
          border-radius: 10px;
          background: linear-gradient(
              90deg,
              rgba(187, 199, 205, 0.2),
              rgba(251, 199, 145, 0.2)
            ),
            linear-gradient(
              180deg,
              rgba(253, 228, 165, 0.2),
              rgba(145, 210, 204, 0.2)
            );
        ">
          <a [routerLink]="['/project']" class="p-3 h-full" style="border-radius: 8px">
              <div class="flex align-items-center justify-content-center bg-bluegray-200 mb-3"
                  style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                  <i class="pi pi-fw pi-id-card text-2xl text-bluegray-700"></i>
              </div>
              <h5 class="mb-2 text-900">{{'PROJECTS'| translate}}</h5>
          </a>
      </div>
  </div>

  <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5  mt-4 lg:mt-0">
      <div class="px-3" style="
          height: 160px;
          padding: 2px;
          border-radius: 10px;
          background: linear-gradient(
              90deg,
              rgba(187, 199, 205, 0.2),
              rgba(246, 158, 188, 0.2)
            ),
            linear-gradient(
              180deg,
              rgba(145, 226, 237, 0.2),
              rgba(160, 210, 250, 0.2)
            );
        ">
          <a [routerLink]="['/annual-plan']" class="p-3 h-full" style="border-radius: 8px">
              <div class="flex align-items-center justify-content-center bg-orange-200 mb-3"
                  style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                  <i class="pi pi-fw pi-star text-2xl text-orange-700"></i>
              </div>
              <h5 class="mb-2 text-900">{{'ANNUAL_PLAN'| translate}}</h5>
          </a>
      </div>
  </div>

  <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5  mt-4 lg:mt-0">
      <div class="px-3" style="
    height: 160px;
    padding: 2px;
    border-radius: 10px;
    background: linear-gradient(
        90deg,
        rgba(251, 199, 145, 0.2),
        rgba(246, 158, 188, 0.2)
      ),
      linear-gradient(
        180deg,
        rgba(172, 180, 223, 0.2),
        rgba(212, 162, 221, 0.2)
      );">
          <a [routerLink]="['/achievements']" class="p-3 h-full" style="border-radius: 8px">
              <div class="flex align-items-center justify-content-center bg-orange-200 mb-3"
                  style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                  <i class="pi pi-fw pi-star text-2xl text-orange-700"></i>
              </div>
              <h5 class="mb-2 text-900">{{'ACHIEVEMENTS'| translate}}</h5>
          </a>
      </div>
  </div>
</div>



<div class="w3-row-padding bottom-content" id="plans">

  <div class="w3-third w3-margin-bottom w3-margin-top ">
    <ul class="w3-ul w3-border w3-center w3-hover-shadow bottom-content-box">
      <li class="w3-large w3-padding-32" style="background:darkseagreen; color:black;"><b>{{'UPCOMING_PROJECTS'| translate}}</b></li>
      <li class="w3-padding-16">{{'UPCOMING_PROJECT1'| translate}}</li>
      <li class="w3-padding-16">{{'UPCOMING_PROJECT2'| translate}}</li>
      <li class="w3-padding-16">{{'UPCOMING_PROJECT3'| translate}}</li>

      <li class="w3-light-grey w3-padding-24">
        <button class="w3-button w3-padding-large" style="background:darkseagreen;">{{'VIEW_MORE'| translate}}</button>
      </li>
    </ul>
  </div>

  <div class="w3-third w3-margin-bottom w3-margin-top ">
    <ul class="w3-ul w3-border w3-center w3-hover-shadow bottom-content-box">
      <li class="w3-large w3-padding-32" style="background:darkseagreen; color:black;"><b>{{'ON_GOING_PROJECTS'| translate}}</b></li>
      <li class="w3-padding-16">{{'ON_GOING_PROJECT1'| translate}}
      </li>
      <li class="w3-padding-16">{{'ON_GOING_PROJECT2'| translate}}</li>
      <li class="w3-padding-16">{{'ON_GOING_PROJECT3'| translate}}</li>





      <li class="w3-light-grey w3-padding-24">
        <button class="w3-button w3-padding-large" style="background:darkseagreen;">{{'VIEW_MORE'| translate}}</button>
      </li>
    </ul>
  </div>

  <div class="w3-third w3-margin-bottom w3-margin-top ">
    <ul class="w3-ul w3-border w3-center w3-hover-shadow bottom-content-box">
      <li class="w3-large w3-padding-32" style="background:darkseagreen; color:black;"><b>{{'IMPORTANT_LINKS'| translate}}</b></li>
      <li class="w3-padding-10 w3-text-blue"><a href="http://hrcada.attendance.gov.in/"
          target="_blank">http://hrcada.attendance.gov.in/</a></li>
      <li class="w3-padding-10 w3-text-blue"><a href="http://web1.hry.nic.in/cfmshcs/"
          target="_blank">http://web1.hry.nic.in/cfmshcs/</a></li>
      <li class="w3-padding-10 w3-text-blue"><a href="http://lmshry.gov.in/" target="_blank">http://lmshry.gov.in/</a>
      </li>
      <li class="w3-padding-10 w3-text-blue"><a href="https://etenders.hry.nic.in/nicgep/app"
          target="_blank">https://etenders.hry.nic.in/nicgep/app</a></li>
      <li class="w3-padding-10 w3-text-blue"><a href="http://hrmshry.nic.in/" target="_blank">http://hrmshry.nic.in/</a>
      </li>
      <li class="w3-padding-10 w3-text-blue"><a href="http://www.hid.gov.in/" target="_blank">http://www.hid.gov.in/</a>
      </li>
      <li class="w3-padding-10 w3-text-blue"><a href="http://www.apprenticeship.gov.in"
          target="_blank">http://www.apprenticeship.gov.in</a></li>
      <li class="w3-padding-10 w3-text-blue"><a href="https://pgportal.gov.in/"
          target="_blank">https://pgportal.gov.in/</a></li>
    </ul>
  </div>
</div>


<footer class="w3-container w3-center" style="background:darkseagreen;height:120px; color:black;">
  <div class="w3-row-padding">
    <div class="w3-center w3-bar-item" style="margin-bottom:5px; color:black;">
      <p><b><strong>{{'MICADA_HARYANA'| translate}}</strong></b><br><b>
        {{'BAYS_39_40_SECTOR_4_PANCHKULA'| translate}}<br>
        {{'FAX_NO'| translate}}<br>
        {{'EMAIL'| translate}}:hrcada@chd.nic.in</b></p>
      <p class="w3-hide-medium w3-hide-small" style="color:rgb(71, 3, 3);"><b>
         Copyright © 2021 Micro Irrigation &
          Command Area Development Authority, Haryana. All Rights Reserved.</b>
      </p>
    </div>
  </div>
</footer>